import React, { useState, useEffect } from "react";
import ActivityTable from "../../component/activity/activity-table";
import SearchForm from "../../component/search-form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  RESET_SAVE_TEMPORARY_DATA,
  CLEAR_COMPONENT_GRID_LAYOUT_DATA,
  SET_RETAIN_PROPS,
  RESET_REDUX_STATE,
  CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY,
} from "../../redux/constants";
import BackButtonWindow from "../../component/Alert/BackButtonWindow";
import { getAllToDO } from "../../redux/actions/todo";
import { sanitizeInput } from "../../utils";
import DownloadComponentModal from "./Component/DownloadToDosModal";

const Manage = () => {
  const { tempPageName, path } = useSelector((state) => state.tempWindowsData);
  const { row_count } = useSelector((state) => state.auth);
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [searchText, setSearchText] = useState();
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [updateTable, setUpdateTable] = useState(0);
  const [openDownloadToDoModal, setOpenDownloadToDoModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    setLoader(true);
    dispatch(
      getAllToDO(
        debouncedSearchText,
        "",
        sortField,
        sortOrder,
        currentPage,
        row_count,
        (res) => {
          setLoader(false);
        }
      )
    );
    dispatch({ type: CLEAR_COMPONENT_GRID_LAYOUT_DATA });
    dispatch({ type: CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY });
  }, [
    currentPage,
    sortField,
    debouncedSearchText,
    sortOrder,
    updateTable,
    row_count,
  ]);

  /*----------------------------------- Implementing Data Table with pagination, sorting, and filtering -----------------------*/

  return (
    <>
      {path !== "" && tempPageName !== "" && (
        <BackButtonWindow
          backButtonName={tempPageName}
          title="Completed creating To Do?"
          path={path}
        />
      )}
      <div className="mt-4 sm:mx-6 lg:mx-8">
        <div className="space-y-2">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
            <div className="space-x-4 flex items-center">
              <h4 className="text-xl leading-5 font-bold tracking-tight">
                To Do List
              </h4>
              <SearchForm
                placeholder="Search"
                onChange={(e) => {
                  const value = sanitizeInput(e.target.value);
                  setSearchText(value);
                }}
                value={searchText}
              />
            </div>
            <div className="space-x-4 flex items-center justify-end">
              <button
                className="btn border-slate-200 hover:border-slate-300 bg-white text-[#1E293B] text-sm leading-3 tracking-tight"
                onClick={() => setOpenDownloadToDoModal(true)}
              >
                Download Existing To Dos
              </button>
              <button
                className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                onClick={() => {
                  if (tempPageName === "manage todo") {
                    dispatch({ type: RESET_SAVE_TEMPORARY_DATA });
                  }
                  dispatch({ type: SET_RETAIN_PROPS, payload: false });
                  dispatch({ type: RESET_REDUX_STATE });
                  navigate("/activity/create");
                }}
              >
                <span className={`fas fa-plus mr-2`}></span>
                Create To Do
              </button>
            </div>
          </div>
          <ActivityTable
            searchText={searchText}
            setDebouncedSearchText={setDebouncedSearchText}
            loader={loader}
            setSortField={setSortField}
            setSortOrder={setSortOrder}
            onPageChange={handlePageChange}
            updateTable={updateTable}
            setUpdateTable={setUpdateTable}
          />
        </div>
        <DownloadComponentModal
          modalOpen={openDownloadToDoModal}
          setModalOpen={setOpenDownloadToDoModal}
          setUpdateTable={setUpdateTable}
          updateTable={updateTable}
        />
      </div>
    </>
  );
};

Manage.auth = { path: "/activity/overview", role: "super-admin admin" };
export default Manage;
